import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApplicationBaseComponent } from "src/app/shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "src/app/shared/services/afla-module-strategy/afla-module-strategy.service";
import { RouterParamsService } from "src/app/shared/services/route-params.service";
import { ViewApplicationDetailsBlConstants } from "./view-application-details-bl.constant";
import { RecipientSelectService } from "src/app/shared/components/recipient-select/shared/service/recipient-select.service";
import { SharedConstants } from "src/app/shared/constants/shared.constants";
import { ViewApplicationService } from "../../../view-application.service";
import { AppControllerService } from "src/app/app-controller.service";
import { CRUDOperation } from "src/app/shared/models/crud-operation-enum.model";
import RecipientUtils from "src/app/shared/utils/recipient-utils";
import { BlService } from "../bl.service";
import { AlertType } from "src/app/shared/models/alert";
let ViewApplicationDetailsBlComponent = class ViewApplicationDetailsBlComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    routerParamsService;
    recipientSelectService;
    appController;
    blService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = ViewApplicationDetailsBlConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = ViewApplicationDetailsBlConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsBlConstants.TYPE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsBlConstants.REFERENCE_NUMBER_CONTROL_NAME;
    referenceNumberLabel = ViewApplicationDetailsBlConstants.REFERENCE_NUMBER_LABEL;
    tradeNameLabel = ViewApplicationDetailsBlConstants.TRADE_NAME_LABEL;
    tradeNameFormControlName = ViewApplicationDetailsBlConstants.TRADE_NAME_CONTROL;
    businessOwnerLabel = ViewApplicationDetailsBlConstants.BUSINESS_OWNER_LABEL;
    businessOwnerFormControlName = ViewApplicationDetailsBlConstants.BUSINESS_OWNER_CONTROL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    descriptionLabel = ViewApplicationDetailsBlConstants.DESCRIPTION_LABEL;
    typeLabel = ViewApplicationDetailsBlConstants.TYPE_LABEL;
    applicationTypes = [];
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    application;
    businessOwnerDisableFilterBy = true;
    businessOwnerDisableAdd = true;
    businessOwnerDisableEditing = false;
    businessOwnerShowFields = true;
    businessOwnerIsInternal = false;
    businessOwnerGroups = [];
    getApplicationObservable;
    getLookupsObservable;
    updateBusinessLicenceBusinessOwner;
    constructor(aflaModuleStrategyService, viewApplicationService, route, routerParamsService, recipientSelectService, appController, blService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.recipientSelectService = recipientSelectService;
        this.appController = appController;
        this.blService = blService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
        }
        else {
            this.getLookups();
        }
        this.getApplication();
    }
    handleRouteChange() {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID} and (name eq 'ApplicationType')`,
        };
        this.getLookupsObservable = this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsBlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.changeDetectorRefs.detectChanges();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
            $expand: "businessOwner"
        };
        this.getApplicationObservable = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsBlConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.tradeNameFormControlName).setValue(application.tradeName);
            const businessOwnerFormControl = this.detailsForm.get(this.businessOwnerFormControlName);
            this.recipientSelectService.setRecipient(application.businessOwner[0], false, businessOwnerFormControl);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            this.detailsForm.get(this.tradeNameFormControlName).disable();
            this.detailsForm.get(this.typeFormControlName).disable();
            // this.detailsForm.get(this.businessOwnerFormControlName).disable();
            let appType = null;
            this.applicationTypes.forEach(item => {
                if (item.value === application.type) {
                    appType = item;
                }
            });
            this.detailsForm.get(this.typeFormControlName).setValue(appType);
        }
        this.changeDetectorRefs.detectChanges();
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const businessOwnerValue = this.detailsForm.get(this.businessOwnerFormControlName).value;
            const businessOwner = RecipientUtils.removeRecipientProperties(businessOwnerValue);
            this.updateBusinessLicenceBusinessOwner = this.blService.updateBusinessLicenceBusinessOwner(businessOwner, this.application.id).subscribe(response => {
                this.appController.showMessage(SharedConstants.SAVED_SUCCESS, AlertType.Success);
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: RecipientSelectService },
        { type: AppControllerService },
        { type: BlService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsBlComponent = __decorate([
    Component({
        selector: "app-view-application-details-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBlComponent);
export { ViewApplicationDetailsBlComponent };
